var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlowSupportSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.592 0 0 3.592 0 8C0 12.408 3.592 16 8 16C12.408 16 16 12.408 16 8C16 3.592 12.408 0 8 0ZM11.48 10.856C11.368 11.048 11.168 11.152 10.96 11.152C10.856 11.152 10.752 11.128 10.656 11.064L8.176 9.584C7.56 9.216 7.104 8.408 7.104 7.696V4.416C7.104 4.088 7.376 3.816 7.704 3.816C8.032 3.816 8.304 4.088 8.304 4.416V7.696C8.304 7.984 8.544 8.408 8.792 8.552L11.272 10.032C11.56 10.2 11.656 10.568 11.48 10.856Z",
    fill: "#F87171"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowSupportSvg);
export default __webpack_public_path__ + "static/media/SlowSupportSvg.c6992c3b7464eb63450a50bd378c8d8b.svg";
export { ForwardRef as ReactComponent };